/**
 * Filters career offer items based on the clicked filter button.
 * Removes active state from all filter buttons, adds active to clicked.
 * If 'All' clicked, shows all career offers.
 * Else hides offers that don't match filter, shows matching ones.
 * Adds click handler to filter buttons to trigger filtering.
 */

function filterCareersOffers(e) {
  document.querySelectorAll('[data-name="filter-custom-btn"]').forEach((btn) => {
    btn.classList.remove("black");
    btn.classList.add("grey", "outline");
  });

  if (e.currentTarget.getAttribute("data-filter-item") == "all") {
    e.currentTarget.classList.remove("grey", "outline");
    e.currentTarget.classList.add("black");

    document.querySelectorAll('[data-name="item-to-filtering"]').forEach((item) => {
      item.classList.remove("hidden");
    });

    if (document.querySelector('.carousel-slider')) {
      var flkty = new Flickity('.carousel-slider');
      flkty.resize();
    }
  } else {
    e.currentTarget.classList.add("black");
    e.currentTarget.classList.remove("grey", "outline");

    document.querySelectorAll('[data-name="item-to-filtering"]').forEach((item) => {
      if (item.getAttribute("data-filter-item").indexOf(e.currentTarget.getAttribute("data-filter-item"))) {
        item.classList.add("hidden");
      } else {
        item.classList.remove("hidden");
      }
    });

    if (document.querySelector('.carousel-slider')) {
      var flkty = new Flickity('.carousel-slider');
      flkty.resize();
    }
  }
}

document.querySelectorAll('[data-name="filter-custom-btn"]').forEach((btn) => {
  btn.addEventListener("click", filterCareersOffers);
});
